import ACTION_TYPES from "../types";
import {GET, POST} from "../../service/axiosMethods"
import { removeUserSession } from "./userActivityAction";
import store from "../store";
import { renderAlert } from "../../CommonComponents/Alert/Alert";
import {  removeLockFromSheetIfUnauthorised } from "./sheetAction";
import { updateWbWhenLogout } from "./workbookAction";

export const getAllUsers = () =>async(dispatch) =>{
  try {
    let res = await GET('/user/getAllUsers')
    let users=[];
    const { userData } = store.getState().userReducer
    if (res) {
      users = res.data.filter((user) => {
         return user.email !== userData.email
     })
 }
    dispatch({type:ACTION_TYPES.SET_ALL_USERS,allUsers:users})
    return users;
  } catch (error) {
    console.log(error);
  }
}

export const getUsersNotInWorkspace=async(workspace_id)=>{
  try{
    let res= await POST('/user/getUsersNotInWorkspace',{workspace_id:workspace_id})
    return res.data;
  }
  catch(err){
    console.log(err)
  }
}

export const getUser = (user) => async (dispatch) => {
  try {
    let signedInUser=user
    if(signedInUser) {
      dispatch({ type: ACTION_TYPES.GET_USER, payload: signedInUser })
      return signedInUser
  }
    else dispatch(signOutUser())
    } catch (error) {
      console.log(error);
    }
}
export const LoginUser=(email,password)=>async(dispatch)=>{
  try{ 
  let res= await POST('/auth/login',{username:email,password});
  setTimeout(() => {
    if (res.data.redirectUrl) {
      window.location.href = res.data.redirectUrl;
    }else{
      window.location.reload();
    }
  }, 1000);
}
catch(e){
  renderAlert ('invalid credential. Please check Your Email and Password.', 'error')
  console.log(e);

}
 
}
export const registerUser=async(body)=>{
  try{
    let res= await POST('/auth/register',body)
    return res.data

  }
  catch(error) {
    console.log("Login error",error);
  }
}
export const signOutUser=() => async(dispatch)=>{
  try{
    //removing user session
    const {userData}=store.getState().userReducer
    const {currentSelectedSheet}=store.getState().sheetReducer
    if (currentSelectedSheet && currentSelectedSheet.id) {
      await removeLockFromSheetIfUnauthorised(currentSelectedSheet.id)
      await updateWbWhenLogout(currentSelectedSheet.workbook_id, userData.email)
    }
    removeUserSession(userData)
    dispatch({ type: ACTION_TYPES.REMOVE_USER });

    let res= await POST('/auth/signOut')
    return res

  }
  catch(error) {
    console.log("Login error",error);
  }
}

export const validateUser = () => async(dispatch) =>{
  try {
    const user = await GET('/auth/validateUser');
    dispatch({ type: ACTION_TYPES.GET_USER, payload: user.data });
    return user;
  } catch (error) {
    console.log("Error in validateUser", );
    dispatch({ type: ACTION_TYPES.GET_USER, payload: null});
  }
}

export const getLoggedInUser = async() =>{
  try {
    const user = await GET('/auth/validateUser');
    return user;
  } catch (error) {
    console.log("Error in validateUser", );
    
  }
}


export const setAuthLoading = (isLoading) => async(dispatch) =>{
  try {
    dispatch({ type: ACTION_TYPES.SET_AUTH_LOADING, authLoading: isLoading });
  } catch (error) {
    console.error("Error in setAuthLoading",error);
    
  }
}